import { render, staticRenderFns } from "./QA_vn.vue?vue&type=template&id=0119d46a&scoped=true&"
import script from "./QA_vn.vue?vue&type=script&lang=js&"
export * from "./QA_vn.vue?vue&type=script&lang=js&"
import style0 from "./QA_vn.vue?vue&type=style&index=0&id=0119d46a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119d46a",
  null
  
)

export default component.exports